/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { CheckIcon } from '@coursera/cds-icons';

import ChipButton from 'bundles/search-common/components/experiments/filters2024/ChipButton';

import courseraPlusLogo from 'images/search-common/coursera_plus.png';

import _t from 'i18n!nls/search-common';

type Props = { isActive: boolean; onClick: () => void };
const styles = {
  imgixWrapper: css`
    display: flex;
    align-items: center;
  `,
};
export const CourseraPlusFilterChipButton = (props: Props): React.ReactElement => {
  const { isActive, onClick } = props;
  return (
    <ChipButton onClick={onClick} prefix={isActive ? <CheckIcon size="large" /> : null} isActive={isActive}>
      <div css={styles.imgixWrapper}>
        <Imgix
          src={courseraPlusLogo}
          maxWidth={80}
          maxHeight={20}
          aria-hidden={true}
          alt={_t('Coursera Plus filter button')}
        />
      </div>
    </ChipButton>
  );
};

export default CourseraPlusFilterChipButton;
